import de from 'date-fns/locale/de'
import deAT from 'date-fns/locale/de-AT'
import enAU from 'date-fns/locale/en-AU'
import enCA from 'date-fns/locale/en-CA'
import enGB from 'date-fns/locale/en-GB'
import enIE from 'date-fns/locale/en-IE'
import enIN from 'date-fns/locale/en-IN'
import enNZ from 'date-fns/locale/en-NZ'
import enUS from 'date-fns/locale/en-US'
import es from 'date-fns/locale/es'
import fr from 'date-fns/locale/fr'
import frCA from 'date-fns/locale/fr'
import frCH from 'date-fns/locale/fr-CH'
import it from 'date-fns/locale/it'
import ja from 'date-fns/locale/ja'
import pt from 'date-fns/locale/pt'
import ru from 'date-fns/locale/ru'
import querystring from 'query-string'

export const supportedLocales = [
    { code: 'de-at', file: deAT },
    { code: 'de-ch', file: de },
    { code: 'de-de', file: de },
    { code: 'en-au', file: enAU },
    { code: 'en-be', file: enGB },
    { code: 'en-ca', file: enCA },
    { code: 'en-dk', file: enGB },
    { code: 'en-fi', file: enUS },
    { code: 'en-hk', file: enGB },
    { code: 'en-hu', file: enGB },
    { code: 'en-ie', file: enIE },
    { code: 'en-in', file: enIN },
    { code: 'en-nl', file: enGB },
    { code: 'en-no', file: enGB },
    { code: 'en-nz', file: enNZ },
    { code: 'en-se', file: enGB },
    { code: 'en-uk', file: enGB },
    { code: 'en-us', file: enUS },
    { code: 'es-es', file: es },
    { code: 'es-mx', file: es },
    { code: 'fr-be', file: fr },
    { code: 'fr-ca', file: frCA },
    { code: 'fr-ch', file: frCH },
    { code: 'fr-fr', file: fr },
    { code: 'it-ch', file: it },
    { code: 'it-it', file: it },
    { code: 'ja-jp', file: ja },
    { code: 'pt-pt', file: pt },
    { code: 'ru-ru', file: ru },
]

export const getLocale = () => {
    const localeArray = supportedLocales.map((localeObj) => localeObj.code)
    return navigator.languages.find((l) =>
        localeArray.includes(l.toLowerCase())
    )
}

export const getLocaleFile = () => {
    const locale = getLocale()
    return supportedLocales.find((l) => {
        return l.code === locale?.toLowerCase()
    })?.file
}

export const getSearchParamsLocale = ()=> querystring.parse(window.location.search)['lang'] as string | undefined

export const getSearchParamsCountryCode = () => getSearchParamsLocale()?.split('-')[1]

export const getSearchParamsLanguage = () => getSearchParamsLocale()?.split('-')[0]
